import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Job } from '@contracts/interfaces/job.interface';
import { JobService } from '../../services/job.service';
import { InvoiceInterface } from '@contracts/interfaces/invoice.interface';
import { InvoicesService } from '../../services/invoices.service';
import { human } from '../../tools/human-currency';
import { PDFService } from 'src/app/services/pdf.service';
import { TemplateService } from '../../services/template.service';

export interface DialogData {
    invoice: InvoiceInterface,
    pdfHash: string
}

@Component({
  selector: 'app-dialog-email-invoice',
  templateUrl: 'email-invoice.dialog.html',
  styleUrls: ['./email-invoice.dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmailInvoiceDialogComponent {

  invoice: InvoiceInterface;
  body: any = {
    HTML: "",
    text: ""
  };
  pdf: string = "";

  email: any = {}

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EmailInvoiceDialogComponent>,
    private invoiceService: InvoicesService,
    private pdfService: PDFService,
    private jobService: JobService,
    private templateService: TemplateService
    ) { }

  ngOnInit() {
    this.invoice = this.invoiceService.validate(this.data.invoice);
    this.pdf = this.data.pdfHash;

    let template = "invoice.template.html"

    if (this.invoice.type == "standard") {
      this.email.sender = {
        name: "Bendigo PC Clinic",
        address: "accounts@bendigopcclinic.com.au"
      }
      this.email.subject = 'Tax Invoice ' + this.invoice.number;

      this.email.attachments = [
        {
          filename: "inv-" + this.invoice.number + "-bendigo-pc-clinic.pdf",
          path: "pdfs/" + this.pdf + "/generated.pdf",
        }
      ]
    } else if (this.invoice.type == "ewaste") {
      template = "invoice-ewaste.template.html";
      
      this.email.subject = 'Tax Invoice ' + this.invoice.number;

      this.email.sender = {
        name: "Bendigo E-Waste",
        address: "collections@bendigoewaste.com.au"
      }

      this.email.attachments = [
        {
          filename: "inv-" + this.invoice.number + "-bendigo-e-waste.pdf",
          path: "pdfs/" + this.pdf + "/generated.pdf",
        }
      ]

    } else if (this.invoice.type == "repair") {
      template = "invoice-repairlab.template.html";
      
      this.email.subject = 'Tax Invoice ' + this.invoice.number;

      this.email.sender = {
        name: "Repair Lab",
        address: "support@repairlab.com.au"
      }

      this.email.attachments = [
        {
          filename: "inv-" + this.invoice.number + "-repair-lab.pdf",
          path: "pdfs/" + this.pdf + "/generated.pdf",
        }
      ]
    } else if (this.invoice.type == "rcti-repairlab") {
      template = "invoice-repairlab.template.html";
      
      this.email.subject = 'Recipient Created Tax Invoice ' + this.invoice.number;

      this.email.sender = {
        name: "Repair Lab",
        address: "support@repairlab.com.au"
      }

      this.email.attachments = [
        {
          filename: "rcti-" + this.invoice.number + "-repair-lab.pdf",
          path: "pdfs/" + this.pdf + "/generated.pdf",
        }
      ]
    } else if (this.invoice.type == "ebay-new-design") {
      template = "invoice-ebay-new-design.template.html";

      this.email.subject = 'Tax Invoice ' + this.invoice.number;

      this.email.sender = {
        name: "Repair Lab",
        address: "support@repairlab.com.au"
      };

      this.email.attachments = [
        {
          filename: "inv-" + this.invoice.number + "-ebay-new-design.pdf",
          path: "pdfs/" + this.pdf + "/generated.pdf",
        }
      ]
    }

    this.templateService.renderFile(template, this.invoice).subscribe((reply: any) => {
        this.body.HTML = reply.render;
    });
  }

  close () {
    this.dialogRef.close(null);
  }

  send() {

    console.log(this.email)

    this.jobService.create({
      job: Job.EMAIL,
      date: {
        start: new Date()
      },
      data: {
        subject: this.email.subject,
        sender: this.email.sender,
        recipients: [
          {
            name: this.invoice.customer.name,
            address: this.invoice.customer.email
          }
        ],
        body: {
          HTML: this.body.HTML,
          text: this.body.text,
        },
        attachments: this.email.attachments
      }
    }).subscribe(job => {

      this.dialogRef.close(job);
    });
  }
}
